export default __webpack_public_path__ + "static/media/abtcp.492c706d.png";